import { ImportProcessResult, ProcessNames, ProcessStatus, UpdateOrdersConfig } from "../api/types";
import { useProcessStatus } from "../hooks/useProcessStatus";
import { useState } from "react";
import { Accordion, Button, Card, Flex, Message, View } from "@aws-amplify/ui-react";
import { RunProcess } from "./RunProcess";
import { UpdateOrdersSettings } from "./UpdateOrdersSettings";

const formatProcessResult = (processResult: ImportProcessResult) => {
  if (processResult.status === 'success') {
    return <Message colorTheme="success" hasIcon={false}>
      {!!processResult.ids?.length ? <>Orders with ids {processResult.ids.join(', ')} were updated successfully</> : <>No
        orders found to update</>}
    </Message>
  } else {
    return processResult.errors?.map(error => <Message colorTheme="error" hasIcon={true}>
      {error.detail}
    </Message>)
  }
}
type ResultProps = {
  result: ProcessStatus['result']
}
const Result = ({ result }: ResultProps) => {
  if (!result) return <></>

  return <Accordion.Container>
    <Accordion.Item value="Accordion-item">
      <Accordion.Trigger>
        <strong>Update orders result</strong>
        <Accordion.Icon/>
      </Accordion.Trigger>
      <Accordion.Content style={{ padding: 10 }}>
        {formatProcessResult(result)}
      </Accordion.Content>
    </Accordion.Item>
  </Accordion.Container>
}

const processName = ProcessNames.UPDATE_ORDERS

export type UpdateOrdersProps = {
  config?: UpdateOrdersConfig
}
export const UpdateOrders = ({config}: UpdateOrdersProps) => {
  const { data: processStatus, isLoading } = useProcessStatus(processName);
  const [showSettings, setShowSettings] = useState(false);

  return <Card variation="outlined">
    <View textAlign="start">
      <Flex justifyContent="space-between">
        <p style={{ fontSize: 16, fontWeight: 'bold', marginTop: 0 }}>Update orders</p>
        {config?.has_product_data_file && <Button size="small" disabled={processStatus?.isRunning}
                                                 onClick={() => setShowSettings(!showSettings)}>{showSettings ? 'Hide settings' : 'Settings'}</Button>}
      </Flex>
      {showSettings ? <UpdateOrdersSettings config={config}/> : <div>
        <div style={{ marginBottom: 20 }}>
          <RunProcess processName={processName}
                      isLoading={processStatus?.isRunning}
                      disabled={isLoading}
          ></RunProcess>
        </div>
        {processStatus?.lastRun &&
            <p>Last run: <span style={{ fontStyle: 'italic' }}>{processStatus?.lastRun}</span></p>
        }

        {processStatus?.isRunning === false && <Result result={processStatus?.result}/>}
      </div>}
    </View>
  </Card>
}